module.exports = __webpack_public_path__ + "img/a6b32c740e405b81e73413da48c30742.png";